import {
  $isTableCellNode,
  $isTableNode,
  $isTableRowNode,
  type TableCellNode,
  type TableRowNode,
  type TableSelection,
} from '@lexical/table';
import { $getNodeByKey } from 'lexical';

export function $tableSelectionToMarkdown(selection: TableSelection): string | null {
  const tableNode = $getNodeByKey(selection.tableKey);
  if (!tableNode || !$isTableNode(tableNode)) {
    return null;
  }

  const shape = selection.getShape();
  const rows = tableNode.getChildren().filter((n): n is TableRowNode => $isTableRowNode(n));

  if (shape.fromY === shape.toY && shape.fromX === shape.toX) {
    const row = rows[shape.fromY];
    if (!row) return null;
    const cells = $getCells(row);
    const cell = cells[shape.fromX];
    return cell ? cell.getTextContent().trim() : null;
  }

  const lines: string[] = [];
  for (let rowIndex = shape.fromY; rowIndex <= shape.toY; rowIndex++) {
    const row = rows[rowIndex];
    if (!row) continue;
    const selectedCells = $getCells(row).slice(shape.fromX, shape.toX + 1);
    const cellTexts = selectedCells.map(cell => ` ${$cellToMarkdown(cell)} `);
    lines.push(`|${cellTexts.join('|')}|`);

    if (rowIndex === shape.fromY) {
      const divider = selectedCells.map(() => ' --- ');
      lines.push(`|${divider.join('|')}|`);
    }
  }

  return lines.join('\n');
}

function $cellToMarkdown(cell: TableCellNode): string {
  return cell.getTextContent().trim().replace(/\|/g, '\\|').replace(/\r?\n/g, '<br>');
}

function $getCells(row: TableRowNode): TableCellNode[] {
  return row.getChildren().filter((n): n is TableCellNode => $isTableCellNode(n));
}
